import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { EventVenueMap } from 'src/components/Events/VenueMap/EventVenueMap';
import { useEventMapContext } from 'src/contexts/EventMapContext';
import { vars } from 'src/core/themes';
import { SponsoredListingsCampaignInput } from 'src/WebApiController';

import * as styles from './CampaignModal.css';

export const ZoneTargetingMapEmbedded = () => {
  const { venueMapInfo } = useEventMapContext();
  const { watch } = useFormContext<SponsoredListingsCampaignInput>();
  const targetTicketClassIds = watch('targetTicketClassIds');

  const selectedSectionIds = useMemo(() => {
    const selectedTcIds = targetTicketClassIds?.value ?? [];
    if (!selectedTcIds.length || !venueMapInfo?.sections) return undefined;
    return venueMapInfo.sections
      .filter((s) =>
        s.rows?.some(
          (r) => r.tktClass?.id != null && selectedTcIds.includes(r.tktClass.id)
        )
      )
      .map((s) => s.id);
  }, [targetTicketClassIds, venueMapInfo]);

  return (
    <div className={styles.embeddedMapContainer}>
      <EventVenueMap
        hideControls={false}
        isZoomEnabled
        isPanEnabled
        isCondensedView
        selectedSectionIds={selectedSectionIds}
        disableHoverEffect
        getColor={(info) => {
          if (info.isSelected) {
            return {
              stroke: vars.color.borderBrand,
              fill: vars.color.backgroundPrimary,
              textColor: 'transparent',
            };
          }
          // White/transparent for non-selected zones
          return {
            fill: vars.color.backgroundPrimary,
            stroke: vars.color.borderSecondary,
          };
        }}
      />
    </div>
  );
};
